/**
 * @ngdoc services
 * @memberof mercury.modules.settings
 * @name CompanyInvoices
 * @description Data access service for Loaded subscription invoices for a company
 */
angular.module('mercury.modules.settings.billing')
.factory('CompanyInvoices', ["$http", "$q", "settings", function($http, $q, settings) {
  /**
   * Get all subscription invoices for the specific company
   *
   * @memberof CompanyInvoices
   * @param  {String} companyId Id of the company
   */
  function getAll(companyId) {
    var deferred = $q.defer();
    $http.get(settings.apiHost + '/r/CompanyInvoices', {headers: {'x-loaded-company-id': companyId}})
    .then(function(response) {
      deferred.resolve(response.data);
    }, function(response) {
      deferred.reject(response);
    });

    return deferred.promise;
  }

  return {
    getAll: getAll
  };
}]);
